/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {BehaviorSubject, Subscription} from "rxjs";
import LatLng = google.maps.LatLng;
import {CompEvent} from "../../models/CompEvent";
import {Venue} from "../../models/Venue";
import Marker = google.maps.Marker;
import {Platform} from "ionic-angular";


@Component({
  selector: 'event-map',
  templateUrl: 'event-map.html'
})
export class EventMap implements OnInit, OnDestroy {


  private _eventLocation: BehaviorSubject<LatLng> = new BehaviorSubject(null);
  private _locationSub: Subscription;
  private _timeout: any;


  eventVenue: Venue;
  public map: google.maps.Map;

  private _venueMarker: google.maps.Marker;

  @Input()
  eventId: string = 'map';

  @Input()
  set venue(venue: Venue) {
    console.log(venue);
    this.eventVenue = venue;
    this._eventLocation.next(new LatLng(venue.latitude, venue.longitude));
  }

  constructor(private platform: Platform, private ref: ChangeDetectorRef) {
    console.log('Hello EventMap Component');
  }

  ngOnInit(): void {

  }

  ngAfterViewInit() {
    this._locationSub = this._eventLocation.subscribe(location => {
      this.map = this.createMap(location);
      if (location) {
        this.setVenueMarker(location);
      }
    });
  }

  ionViewDidLoad() {
    this.createMap();
  }

  createMap(location: LatLng = new LatLng(this.eventVenue.latitude, this.eventVenue.longitude)) {
    console.log('creating map');

    let mapOptions = {
      centre: location,
      zoom: 15,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      disableDefaultUI: true,
      draggable: false,
      scrollwheel: false,
      panControl: false
    };

    let mapElement = document.getElementById(this.eventId);
    if (mapElement) {
      mapElement.classList.add('map-class');
    }
    console.log(mapElement);
    let map = new google.maps.Map(mapElement, mapOptions);

    return map;
  }

  private setVenueMarker(position: LatLng) {
    console.log('setting marker');

    this._venueMarker = new google.maps.Marker({
      map: this.map,
      animation: google.maps.Animation.DROP,
      position: position,
    });

    this.ref.detectChanges();

    this._venueMarker.addListener('click', () => {
      // this.platform.ready().then(() => {
      //
      //   let browser = new InAppBrowser();
      //   browser.create(this.getLink(position), '_system');
      // });
    });

    this.map.panTo(position);

    this._timeout = setTimeout(() => {
      this._venueMarker.setAnimation(null);
    }, 2000);
  }


  ngOnDestroy(): void {
    if (this._timeout) {
      clearTimeout(this._timeout);
    }

    if (this._locationSub) {
      this._locationSub.unsubscribe();
      this._locationSub = null;
    }
  }


}



// WEBPACK FOOTER //
// ./src/components/event-map/event-map.ts